import Nav from "./Nav";
import Hero from "./Hero";
import Marquee from "./Marquee";
import Services from "./Services";
import CoverageBand from "./CoverageBand";
import HoursArea from "./HoursArea";
import QuoteForm from "./QuoteForm";
import Proof from "./Proof";
import Footer from "./Footer";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="bg-[#0b101b] text-slate-100 min-h-screen">
      <Nav />
      <Hero />
      <Marquee />
      <Services />
      <CoverageBand />
      <HoursArea />
      <QuoteForm />
      <Proof />
      <Footer />
    </div>
  );
}
